import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ScanBarcode } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader, Loading } from "@/components/Common";
import { ReturnForm } from "@/components/returns/ReturnForm";
import { useRetMeta } from "@/components/returns/RetCommon";
import { api, errMsg } from "@/lib/api";

export default function ReceiveReturn() {
  const meta = useRetMeta();
  const nav = useNavigate();
  const ref = useRef(null);
  const [tid, setTid] = useState("");
  const [pre, setPre] = useState(null);
  const [today, setToday] = useState(null);
  useEffect(() => { ref.current?.focus(); }, [pre]);
  const scan = async (e) => {
    e.preventDefault();
    const t = tid.trim();
    if (!t) return;
    try {
      const { data } = await api.get("/returns/lookup", { params: { tracking_id: t } });
      setToday(data.received_today);
      if (data.existing) { toast.info(`${data.existing.return_id} already exists — opening it`); nav(`/returns/r/${data.existing.id}`); return; }
      setPre({ ...data.prefill, _k: Date.now() });
      toast[data.from_shipment ? "success" : "info"](data.from_shipment ? "Filled from Shipment Desk" : "No shipment found — fill the details");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const saved = (r) => { toast.success(`${r.return_id} received`); setPre(null); setTid(""); setToday((n) => (n ?? 0) + 1); };
  if (!meta) return <Loading />;
  return (
    <div className="mx-auto max-w-2xl" data-testid="receive-return">
      <PageHeader title="Receive Return" subtitle="Scan the parcel's AWB. Existing returns open, known shipments fill in automatically." />
      <form onSubmit={scan} className="panel mb-4 p-4">
        <label className="mb-2 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-muted-foreground"><ScanBarcode className="h-4 w-4" />Scan or type Tracking ID</label>
        <Input ref={ref} autoFocus value={tid} onChange={(e) => setTid(e.target.value)} className="h-14 font-mono text-2xl" placeholder="AWB / tracking number" data-testid="receive-scan-input" />
        {today != null && <div className="mt-2 text-sm text-muted-foreground" data-testid="received-today"><b className="font-mono text-foreground">{today}</b> received today</div>}
      </form>
      {pre && <ReturnForm key={pre._k} meta={meta} initial={pre} onSaved={saved} compact />}
    </div>
  );
}
